import { motion } from "framer-motion";
import { TypingText } from "../useful/CustomText";

import styles from "../Home";
import { fadeIn, staggerContainer } from "../useful/motion";

const About = () => (
  <section className={`${styles.paddings} relative z-7`}>
    <div className="gradient-02 z-0" />
    <motion.div
      variants={staggerContainer}
      initial="hidden"
      whileInView="show"
      viewport={{ once: false, amount: 0.25 }}
      className={`${styles.innerWidth} mx-auto ${styles.flexCenter} flex-col`}
    >
      <TypingText title="ABOUT US" textStyles="text-center recenter" />
      <div className="infos aboutdisposition">
        <motion.p
          variants={fadeIn("up", "tween", 0.2, 1)}
          className="text-style text-center aboutelement"
          style={{ marginTop: 0 }}
        >
          <img
            src="https://static.igem.wiki/teams/4888/wiki/puzzle.png"
            alt="12"
            className="icon-center"
          />
          <br></br>
          Multidiciplinary team
        </motion.p>
        <motion.p
          variants={fadeIn("up", "tween", 0.2, 1)}
          className="text-center aboutelement text-style"
        >
          <img
            src="https://static.igem.wiki/teams/4888/wiki/12.png"
            alt="12"
            className="icon-center icon-number"
          />
          <br></br>
          motivated members
        </motion.p>
        <motion.p
          variants={fadeIn("up", "tween", 0.2, 1)}
          className="text-style text-center aboutelement"
        >
          <img
            src="https://static.igem.wiki/teams/4888/wiki/gears.png"
            alt="12"
            className="icon-center"
          />
          <br></br>7 Bachelor students <br></br>5 Master students
        </motion.p>
      </div>
      <motion.p
        variants={fadeIn("up", "tween", 0.2, 1)}
        className="sm:text-[32px] text-[20px] visitotherpage relative"
      >
        <a href="../epfl/team">Visit our team page.</a>
      </motion.p>
    </motion.div>
  </section>
);

export default About;
